import {LABELS} from '../constants/labels'

export function blockedCommentingReason(
  isRepoArchived: boolean,
  isReferenceLocked: boolean,
  customReason: string | React.ReactElement | null | undefined = null,
  subjectType: string = 'issue',
  isRepoLocked: boolean = false,
) {
  if (isRepoArchived) return LABELS.repoArchived
  if (isRepoLocked) return LABELS.repoLockedForMigration
  if (isReferenceLocked) return LABELS.issueLockedToCollaborators
  if (customReason) return customReason

  return LABELS.canNotComment(subjectType)
}
